import { makeStyles } from '@material-ui/core';

export const useCollapsableStyles = makeStyles((theme) => ({
  box: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme.colors.cmp.Button.Container_Primary.active.background,
    borderRadius: '8px',
    padding: theme.spacing(1, 2),
    width: '100%',
    '&.noStyle': {
      border: 'none',
      padding: 0,
      background: 'transparent',
    },
    '&.row': {
      flexDirection: 'row',
    },
    '&.column': {
      flexDirection: 'column',
    },
    '& .infoItem': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      color: theme.colors.Text_1,
      width: '100%',
      padding: '0',
      '&:first-child': {
        marginTop: '0 !important',
      },
      '&.total': {
        color: theme.colors.Text_1,
        marginTop: '1em',
      },
      '& .MuiListItemText-primary': {
        fontWeight: 'bold',
      },
      '& .value': {
        textAlign: 'end',
        '&.bonus': {
          color: theme.colors.Text_1,
        },
      },
      '&.discount': {
        '& .value': {
          color: theme.colors.Text_1,
        },
      },
      '& .collapsable-title': {
        alignSelf: 'flex-start',
        margin: '7px 0',
        '&.textOnly': {
          minWidth: 'auto',
        },
        '& > *': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          '& svg': {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
    '& .subtitle': {
      fontWeight: 'bold',
      marginBottom: '1em',
      alignSelf: 'flex-start',
    },
  },
}));
